import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18next from 'i18next'
import { bindActionCreators } from 'redux'
import { languageSwitchItem, getCurrentLanguage } from '../../actions/locales'
import { getSupportedCA, getConnecteds, changeServiceLanguage } from '../../actions/api'
import { setListCSK, setPassiveTokenPath, setActiveTokenPath, showVisualImpairmentView, setContrast, setFontSize } from '../../actions/localStates'
import ServiceConnectionStatus from './ServiceConnectionStatus'
import Downloads from './Downloads'
import CountDownTimer from './CountDownTimer'

import Cookies from 'universal-cookie';

// import logo from '../../img/sjwsa-client-logo.png'
// import logo from '../../img/newLogo.png'

import logo from '../../img/logo-key.png'
import logoText from '../../img/logo-cipher-text.png'
import logoTextEn from '../../img/logo-cipher-text-en.png'

const availableLanguege = ["uk", "en"];
const availableLanguegeValue = ["УКР", "ENG"];

const cookies = new Cookies();

class Header extends Component {

	constructor(props) {
    	super(props);
    	this.state = {
	    	showApps: false
	    }

		this.showVisualImpairmentView = this.showVisualImpairmentView.bind(this)
		this.setContrast = this.setContrast.bind(this)

		this.setFontSizePlus = this.setFontSizePlus.bind(this)
		this.setFontSizeMinus = this.setFontSizeMinus.bind(this)
		this.setFontSizeReset = this.setFontSizeReset.bind(this)

		this.handleShowApps = this.handleShowApps.bind(this);
	    this.closeApps = this.closeApps.bind(this);
	}

	handleShowApps (event) {
		event.preventDefault();
		this.setState({
				showApps: !this.state.showApps
			}, () => {
			document.addEventListener('click', this.closeApps);
		});
	}

	closeApps(event) { 
		this.setState({ showApps: false }, () => {
			document.removeEventListener('click', this.closeApps);
		});  
	}

	showVisualImpairmentView () {
		this.props.actions.showVisualImpairmentView(!this.props.baseUrls.showVisualImpairmentView)
	}

	setContrast () {
		this.props.actions.setContrast(!this.props.baseUrls.contrast)
	}

	setFontSizePlus () {
		if (this.props.baseUrls.fontSize < 4) {
			this.props.actions.setFontSize(this.props.baseUrls.fontSize + 1)
		} else {
			this.props.actions.setFontSize(4)
		}
	}

	setFontSizeMinus () {
		if (this.props.baseUrls.fontSize > 0) {
			this.props.actions.setFontSize(this.props.baseUrls.fontSize - 1)
		} else {
			this.props.actions.setFontSize(0)
		}
	}

	setFontSizeReset () {
		this.props.actions.setFontSize(0)
	}

	componentDidMount() {
		i18next.changeLanguage('uk');
		this.props.actions.getCurrentLanguage('uk');
	}

	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.connectionStatus.baseUrl !== null) {
	// 		if (nextProps.connectionStatus.baseUrl !== this.props.connectionStatus.baseUrl) {
	// 			this.props.actions.getSupportedCA(nextProps.connectionStatus.baseUrl)
	// 			.then((response) => {
	// 				this.props.actions.setListCSK(response.ca)
	// 			})

	// 			if (nextProps.connectionStatus.uccConnection) {
	// 				this.props.actions.getConnecteds(nextProps.connectionStatus.baseUrl)
	// 		    	.then((response) => {
	// 		    		console.log(response);
	// 		    		if (response.passiveTokenPath.length > 0) {
	// 		    			this.props.actions.setPassiveTokenPath(response.passiveTokenPath)
	// 		    		}
	// 		    		if (response.activeTokenPath.length > 0) {
	// 		    			this.props.actions.setActiveTokenPath(response.activeTokenPath)
	// 		    		}
	// 		    	})
	// 		    }
	// 		}
	// 	} else {
	// 		return
	// 	}
	// }

	changeLang(lang){
		this.props.actions.getCurrentLanguage(lang);
        this.props.actions.languageSwitchItem('eng', lang, availableLanguege);
        this.props.actions.changeServiceLanguage(this.props.connectionStatus.baseUrl, lang);
        document.title = i18next.t("serviceTitle");
    }

    _renderLanguageButtonLine() {

	    function options(child, index) {
	      let activeClass = (this.props.language === child ? 'btn lang-button-active btn-sm' : 'btn lang-button btn-sm');
	      let textValue = (availableLanguegeValue[index])

	      return (
	        <button key={child} className={activeClass} style={{marginLeft: "7px"}} onClick={this.changeLang.bind(this, child)}>{textValue}</button>
	      );
	    }

	    return (
	    	<div id="languageButtonLine" className="text-right margin-right-0-media">
	    		{availableLanguege.map(options.bind(this))}
	        </div>
	    );
	}

	redirectToApp(url) {
		if (this.props.baseUrls.token !== null && this.props.baseUrls.token.length > 0) {
			cookies.set('caasJwtToken', this.props.baseUrls.token, { path: '/', expires: new Date(Date.now() + 10000), domain: this.props.baseUrls.domain, secure: true, sameSite: 'none' });
		}

		window.location.href = url;	
	}

	render() {
		let showAppsOpen = 'dropdown-menu'
		if (this.state.showApps) {
			showAppsOpen = 'dropdown-menu show'
		}

		return (
			<div className="col-md-12 col-sm-12 col-xs-12">
				<div>
		        	{
		        		this.props.baseUrls.showVisualImpairmentView
		        		? <div className="margin-padding-0" style={{paddingTop: "7px"}}>
		        			<div className="visual-impairment">
			        			<div className="visual-impairment-container">
				        			<div className="visual-impairment-div">
				        				<div className="visual-impairment-buttons">
				        					<div className="visual-impairment-filter">
				        						<div className="visual-impairment-title">
				        							{i18next.t("contrast")}
				        						</div>
				        						<button className="btn visual-impairment-panel-buttons" onClick={this.setContrast}><i class="fa fa fa-adjust"></i></button>
				        					</div>
				        					<div className="visual-impairment-panel-size">
				        						<button className="btn visual-impairment-panel-buttons" onClick={this.setFontSizePlus}><i className="fa fa-plus"></i></button>
				        						<button className="btn visual-impairment-panel-buttons" onClick={this.setFontSizeMinus}><i className="fa fa-minus"></i></button>
				        						<button className="btn visual-impairment-panel-buttons" onClick={this.setFontSizeReset}><i className="fa fa-rotate-right revert-img"></i></button>
				        					</div>
					        			</div>
					        			<div className="visual-impairment-hide">
					        				<button className="btn visual-impairment-panel-buttons" onClick={this.showVisualImpairmentView}><i className="fa fa-times"></i></button>
					        			</div>
				        			</div>
				        		</div>
			        		</div>
			        	</div>
		        		: null
		        	}
		        </div>
				<div className="row mtb-default" style={{marginLeft: "0px"}}>
			        <div className="col-md-8 col-sm-12 col-12 text-left row mobile-center margin-right-15">
			            <div className="header-wrapper">
						  <div className="header-content">

						    <img
						      className="main-logo margin-top-0"
						      src={logo}
						      width="200"
						      height="60"
						      alt="Logo"
						    />

						    <div className="right-block">
						      <h4 className="service-title selected-element margin-top-0">
						        {i18next.t("clientForService")}
						      </h4>

						      <img
						        className="logo-text margin-top-0"
						        src={this.props.language === "en" ? logoTextEn : logoText}
						        width="150"
						        height="25"
						        alt="LogoText"
						      />
						    </div>

						  </div>
						</div>
				        </div>
			        
			        <div className="col-md-4 col-sm-12 col-xs-12 text-center text-muted">
			        	<ServiceConnectionStatus connectionStatus={this.props.connectionStatus} url={this.props.baseUrls} />
			        </div>
			    </div>
			    <div className="row mtb-default" style={{marginBottom: "0px", marginLeft: "0px", marginRight: "0px"}}>
			        <div className="" style={{marginRight: "10px"}}>
			    		{
				    		this.props.baseUrls.apps !== undefined && this.props.baseUrls.apps.length > 0 && !this.props.mobileModeReducer.isMobileDevice
				    		? <div className="" style={{paddingLeft: "0px", paddingRight: "0px"}}>
								<i className="fa fa-bars fa-2x" type="button" style={{color: "#0ABAB5"}} onClick={this.handleShowApps} data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.showApps}></i>
								<div className={showAppsOpen} style={{minWidth: "180px", maxWidth: "250px"}}>
									{
										this.props.baseUrls.apps.map((item, index) => {
											return <div className="header-span" key={index} onClick={this.redirectToApp.bind(this, item.url)} style={{textDecoration: "none", cursor: "pointer", paddingLeft: "15px"}}>{item.clientTitle}</div>
										})	
									}
								</div>
							</div>
							: null
				    	}
			    	</div>
			    	<CountDownTimer />
			    	<div className="" style={{textAlign: "right", marginLeft: "auto", color: "#1B4965"}}>
			        	<span style={{cursor: "pointer"}} onClick={this.showVisualImpairmentView}><i className="fa fa-low-vision fa-2x"></i></span>
			        </div>
			    	{this._renderLanguageButtonLine()}
			    </div>

			    {/*<hr />*/}
			    <Downloads connectionStatus={this.props.connectionStatus.status} url={this.props.baseUrls} />		    
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        localesReducer: state.localesReducer,
        language: state.localesReducer.language,
        connectionStatus: state.connectionStatusReucer,
        baseUrls: state.base,
        mobileModeReducer: state.mobileModeReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
	    getCurrentLanguage,
	    getSupportedCA,
	    setListCSK,
	    getConnecteds,
	    setPassiveTokenPath,
	    setActiveTokenPath,
	    changeServiceLanguage,
	    showVisualImpairmentView,
	    setContrast, setFontSize
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);